import { Field, FieldProps } from 'react-final-form';

import { Slider, SliderProps, SliderValue } from '@cast/design-system';

import { useControlsGroupState } from './controls-state';
import { useRffFormState } from '../hooks';

type Props = Omit<SliderProps, 'value' | 'onChange' | 'onFocus' | 'onBlur'> & {
  name: string;
  fieldProps?: Partial<FieldProps<SliderValue, any>>;
  readOnly?: boolean;
  disabled?: boolean;
};

export const RffSlider = ({
  fieldProps,
  name: propName,
  readOnly: propReadOnly,
  ...sliderProps
}: Props) => {
  const { mode } = useRffFormState();
  const { disabled, readOnly, name } = useControlsGroupState({
    disabled: sliderProps.disabled || mode === 'view',
    readOnly: mode === 'view' || propReadOnly,
    name: propName,
  });

  return (
    <Field
      {...fieldProps}
      name={name || propName}
      render={(props) => {
        const {
          input: { onBlur, onFocus, onChange, value },
        } = props;
        return (
          <Slider
            onBlur={onBlur}
            onFocus={onFocus}
            onChange={onChange}
            value={value}
            {...sliderProps}
            disabled={disabled || readOnly}
          />
        );
      }}
    />
  );
};
